import React from "react";

function Panasonic() {
    return(
        <h1>the panasonic page
        This si </h1>
    );
}

export default Panasonic